import { MutableRefObject } from "react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { gsap } from "gsap/dist/gsap";

export default function scrollTriggerInit(
  sectionName: string,
  isHero: boolean,
  containerRef: MutableRefObject<any>,
  imagesTl: any,
  textTl?: any,
  rotationTl?: any,
  canAnimationBePaused?: boolean
) {
  // kill animations if it exist
  if (ScrollTrigger.getById(sectionName + "-animations")) {
    ScrollTrigger.getById(sectionName + "-animations").kill();
  }

  // if not hero
  if (!isHero) {
    setTimeout(() => {
      gsap.to(containerRef.current, {
        scrollTrigger: {
          id: sectionName + "-animations",
          markers: false,
          trigger: containerRef.current,
          start: "top bottom-=5%",
          end: "bottom top+=5%",
          onEnter: () => {
            if (textTl) {
              textTl.play();
            }

            if (
              rotationTl &&
              ScrollTrigger.getById(`${sectionName}-animations`).progress !== 0
            ) {
              rotationTl.play();
            }
            imagesTl.play();
          },
          onEnterBack: () => {
            if (textTl) {
              textTl.play();
            }

            if (rotationTl) {
              rotationTl.play();
            }

            imagesTl.play();
          },
          onLeave: () => {
            if (canAnimationBePaused) {
              if (textTl) {
                textTl.pause();
              }

              if (rotationTl) {
                rotationTl.pause();
              }

              imagesTl.pause();
            }
          },
          onLeaveBack: () => {
            if (canAnimationBePaused) {
              if (textTl) {
                textTl.pause();
              }

              if (rotationTl) {
                rotationTl.pause();
              }

              imagesTl.pause();
            }
          },
        },
      });
    }, 800);
  }
}
